import { render, staticRenderFns } from "./UpdateUserForm.vue?vue&type=template&id=d7b194d2&"
import script from "./UpdateUserForm.vue?vue&type=script&lang=ts&"
export * from "./UpdateUserForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports